import mapDocument from "../utils/mapDocument";

export default function getDocumentData(ref) {
	if (ref) {
		return ref.get().then(mapDocument);
	}
}
